async function maybePolyfillWebCrypto() {
  // no need to polyfill if crypto.subtle is already available
  if (window.crypto?.subtle) return
  // we only want to polyfill on http origins
  if (location.protocol !== 'http:') return
  // only polyfill on .local domains and ip addresses
  if (!(location.hostname.endsWith('.local') || /\d+\.\d+\.\d+\.\d+/.test(location.hostname)))
    return
  await import('webcrypto-liner-shim')
}

export default function () {
  return Promise.all([maybePolyfillWebCrypto()])
}
